export const nsoncustomer = {
  common: 'libraries.oncustomer.common',
  myData: 'libraries.oncustomer.myData'
};